module.exports = __webpack_public_path__ + "img/savings.39f89da2.png";